import React, { useState } from 'react'
import Container from '../../ui/container/Container'
import { useSelector } from 'react-redux';
import { getFileUrl } from '../../../utils/helper';
import { useNavigate } from 'react-router-dom';
import { FORM_ROUTE, SHOW_FORM_ROUTE } from '../../../routes/web/rootRoutes';
import PaymentOptions from './PaymentOptions';

function DownloadApply() {
  const navigate = useNavigate();
  const [showPayment, setShowPayment] = useState(false);
  const forms = useSelector((state) => state.globalState?.siteSetting?.formData);
  const user = useSelector((state) => state.globalState?.userProfile);


  const handleApply = (formType) => {
    if (
      formType === 'NEW MEMBERSHIP APPLICATION ART DEPARTMENT' ||
      formType === 'NEW MEMBERSHIP APPLICATION COSTUME DEPARTMENT'
    ) {
      return navigate(FORM_ROUTE(formType));
    }

    if (!user?.is_total_paid) {
      setShowPayment(true);
      return;
    }

    if (localStorage.getItem('useAccessToken') !== null) {
      return navigate(FORM_ROUTE(formType));
    }

    navigate('/auth/login');
  };
  const stripHtml = (html) => {

    if (typeof window === 'undefined') return html || "";
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const getFormColor = (type) => {
    const colorMap = {
      'MEDICAL': 'bg-blue-100 text-blue-800 border-blue-200',
      'REGISTRATION': 'bg-purple-100 text-purple-800 border-purple-200',
      'NOMINATION': 'bg-green-100 text-green-800 border-green-200',
      'UPGRADATION': 'bg-amber-100 text-amber-800 border-amber-200',
      'COMPLAINT': 'bg-red-100 text-red-800 border-red-200'
    };

    for (const [key, value] of Object.entries(colorMap)) {
      if (type.includes(key)) return value;
    }

    return 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getFormIcon = (type) => {
    const iconMap = {
      'MEDICAL': '🏥',
      'REGISTRATION': '📝',
      'NOMINATION': '👥',
      'UPGRADATION': '📈',
      'COMPLAINT': '📢'
    };

    for (const [key, value] of Object.entries(iconMap)) {
      if (type.includes(key)) return value;
    }

    return '📄';
  };

  return (
    <div className='bg-gradient-to-br from-blue-50 to-indigo-50'>
      <Container>
        {showPayment && (
          <div className="fixed z-50 inset-0 flex items-center justify-center bg-black/50">
            <PaymentOptions />
          </div>
        )}

        <div className="min-h-screen ">
          <div className="mx-auto max-w-7xl">
            <div className="mb-12 text-center">
              <h1 className="mb-4 text-4xl font-bold text-gray-900">Available Forms</h1>
              <p className="max-w-3xl mx-auto text-lg text-gray-600">
                Browse through our collection of forms for various services. Apply online or download the forms for offline use.
              </p>
            </div>

            <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
              {forms?.map((form) => {
                const formColor = getFormColor(form.type);
                const formIcon = getFormIcon(form.type);

                return (
                  <div
                    key={form.id}
                    className="flex flex-col overflow-hidden transition-all duration-300 transform bg-white shadow-lg rounded-2xl hover:shadow-xl hover:-translate-y-1"
                  >
                    <div className={`p-5 border-b ${formColor} flex items-center justify-between`}>
                      <div className="flex items-center">
                        <span className="mr-3 text-2xl">{formIcon}</span>
                        <span className="text-sm font-semibold">{form.type}</span>
                      </div>
                      <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-white rounded-full bg-opacity-80">
                        {form.status}
                      </span>
                    </div>

                    <div className="flex-grow p-6">
                      <div className="flex items-start justify-between mb-4">
                        <h2 className="text-lg font-bold leading-tight text-gray-900">{form.title}</h2>
                        <span className="ml-2 text-xs text-gray-500 whitespace-nowrap">
                          {new Date(form.created_at).toLocaleDateString()}
                        </span>
                      </div>

                      {form.sub_heading && form.sub_heading !== form.title && (
                        <p className="mb-4 text-sm text-gray-600">{form.sub_heading}</p>
                      )}

                      <div className="p-4 mb-6 text-sm text-gray-700 rounded-lg bg-gray-50">
                        {stripHtml(form.description).length > 120
                          ? `${stripHtml(form.description).substring(0, 120)}...`
                          : stripHtml(form.description)
                        }
                      </div>
                    </div>

                    <div className="p-5 border-t border-gray-100 bg-gray-50">
                      <div className="flex flex-col gap-3 sm:flex-row">
                        <button
                          onClick={() => handleApply(form.type)}
                          className="flex items-center justify-center flex-1 px-4 py-3 text-sm font-semibold text-white transition-all duration-300 rounded-lg shadow-md cursor-pointer bg-violet-600 hover:bg-violet-800 hover:shadow-lg"
                        >
                          <span className="mr-2">📋</span>
                          Apply Now
                        </button>
                        <a
                          href={getFileUrl(form?.form, 'form')}
                          target='_blank'
                          className="flex items-center justify-center flex-1 px-4 py-3 text-sm font-medium text-gray-700 transition-all duration-300 border border-gray-300 rounded-lg cursor-pointer hover:bg-zinc-400 hover:text-white"
                        >
                          <span className="mr-2">⬇️</span>
                          Download
                        </a>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

          </div>
        </div>
      </Container>
    </div>

  );
};

export default DownloadApply
